import { type RootState } from '@store/rootReducer';
import { createSelector } from 'reselect';

export const selectSettings = (state: Pick<RootState, 'settings'>) =>
  state.settings;

export const selectThemeState = createSelector(
  selectSettings,
  settings => settings.theme,
);

export const selectCurrencyFormatState = createSelector(
  selectSettings,
  settings => settings.currencyFormat,
);
